import React from "react";

// --- Main PlateView Component ---
const PlateView = ({ plate }) => {
    // onToggle
    // --- 1. Plate Data Parsing ---
    // Use vehicle plate or a default to prevent errors.
    const plateNumber = plate || "0-ሀሀ-00000-ZZ";
    const parts = plateNumber.split("-");

    const code = parts[0] || "0";
    const regionAmRaw = parts[1] || "ሀሀ";
    const number = parts[2] || "00000";
    const regionEnRaw = parts[3] || "ZZ";

    // Format region text with a newline for vertical display.
    const regionAm = `${regionAmRaw[0] || "ሀ"}\n${regionAmRaw[1] || "ሀ"}`;
    const regionEn = `${regionEnRaw[0] || "Z"}\n${regionEnRaw[1] || "Z"}`;

    // --- 2. Dynamic Style Logic ---
    // This section replicates the `setUpPlateColor` function from your Kotlin code.

    // --- Corrected Switch Statement ---
    // These colors are now mapped directly from your provided colors.xml values.
    let plateColors = {};
    switch (code) {
        case "1": // Taxi
            plateColors = {
                color: "#B5451F", // R.color.colorTaxi
                plateBg: "#FBE6DE", // A light background for the taxi plate
                codeBg: "#B5451F", // Same as 'color'
            };
            break;
        case "2": // Private
            plateColors = {
                color: "#27479F", // R.color.colorPrivate
                plateBg: "#D4DDFF", // A light background for the private plate
                codeBg: "#27479F", // Same as 'color'
            };
            break;
        case "3": // Business
            plateColors = {
                color: "#326100", // R.color.colorBusiness
                plateBg: "#E0F3CD", // A light background for the business plate
                codeBg: "#326100", // Same as 'color'
            };
            break;
        case "4": // Government
            plateColors = {
                color: "#000000", // R.color.colorGovernment
                plateBg: "#E0E0E0", // A light background for the government plate
                codeBg: "#000000", // Same as 'color'
            };
            break;
        case "5": // NGO
            plateColors = {
                color: "#EA4204", // R.color.colorNGO
                plateBg: "#FFDDD1", // A light background for the NGO plate
                codeBg: "#EA4204", // Same as 'color'
            };
            break;
        default: // Default
            plateColors = {
                color: "#000000", // R.color.colorDefault
                plateBg: "#E0E0E0", // A light background for the default plate
                codeBg: "#000000", // Same as 'color'
            };
            break;
    }

    // Determine the background color for the region text (e.g., for "CD" plates).
    const regionBackgroundColor = regionEnRaw === "CD" ? "#FFC107" : "transparent";
    const regionColor = regionEnRaw === "CD" ? "#000000" : plateColors.color;

    // --- 3. Inline Style Definitions ---
    // All styles are defined here as JavaScript objects.
    const styles = {
        // plateContainer: {
        //     display: "inline-flex",
        //     justifyContent: "center",
        //     alignItems: "center",
        //     cursor: "pointer",
        //     userSelect: "none", // Prevents text selection on click
        // },
        plateContainer: {
            display: "flex",
            alignItems: "center",
            padding: "3px 4px",
            // minHeight: "52px",
            cursor: "pointer",
            userSelect: "none",
            // backgroundColor: isSelected ? "rgba(44, 62, 80, 0.08)" : "transparent",
            // borderLeft: isSelected ? "4px solid #2c3e50" : "4px solid transparent",
            // borderBottom: "1px solid rgba(0,0,0,0.05)",
            transition: "all 0.2s ease",
        },
        plateWhiteBg: {
            backgroundColor: "#FFFFFF",
            padding: "1px",
            borderRadius: "4px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        },
        plateRect: {
            display: "flex",
            height: "34px",
            alignItems: "center",
            justifyContent: "center",
            paddingLeft: "8px",
            paddingRight: "4px",
            borderRadius: "3px",
            fontWeight: "bold",
            color: plateColors.color, // Dynamic color
            // backgroundColor: plateColors.plateBg, // Dynamic background
            border: `2px solid ${plateColors.color}`, // Dynamic border
        },
        codeTxt: {
            width: "18px",
            height: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "'PlateFont', sans-serif",
            fontSize: "12px", // Slightly larger font size for clarity
            fontWeight: "bold",
            textAlign: "center",

            // --- Key changes for the circular border ---
            boxSizing: "border-box", // Ensures the border is inside the 18x18px box
            borderRadius: "50%", // This makes the element a circle
            border: `2px solid ${plateColors.codeBg}`, // Defines the border's width, style, and color
            color: plateColors.codeBg, // Sets the text color to match the border
            backgroundColor: "transparent", // Ensures the inside of the circle is clear
        },
        regionTxt: {
            fontSize: "12px",
            height: "28px",
            marginLeft: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "pre-wrap", // This makes the '\n' work
            textAlign: "center",
            lineHeight: 1.1,
            padding: "0 2px",
            color: regionColor, // Dynamic color for region
            backgroundColor: regionBackgroundColor, // Dynamic background for region
        },
        divider: {
            width: "4px",
            height: "4px",
            backgroundColor: "#8D8D8D",
            margin: "0 4px",
        },
        numberTxt: {
            fontSize: "24px",
            height: "26px",
            fontFamily: "'PlateFont', sans-serif",
            display: "flex",
            alignItems: "center", // Simulates gravity="top"
            color: plateColors.color, // Dynamic color
        },
    };

    // --- 4. JSX Render ---
    return (
        <div style={styles.plateContainer}>
            {/* //onClick={() => onToggle(vehicle.id)} */}
            <div style={styles.plateWhiteBg}>
                <div style={styles.plateRect}>
                    <div style={styles.codeTxt}>{code}</div>
                    <div style={styles.regionTxt}>{regionAm}</div>
                    <div style={styles.divider}></div>
                    <div style={styles.numberTxt}>{number}</div>
                    <div style={styles.regionTxt}>{regionEn}</div>
                </div>
            </div>
        </div>
    );
};

export { PlateView };
